/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseCarouselItemFragment, CarouselItemFragment, FullCarouselItemFragment} from '@amblique/contentful/app/contentful/fragments/carousel-item';

/**
 * Get a single CarouselItem by ID (base - scalars only)
 */
export const getBaseCarouselItemById = gql`
  ${BaseCarouselItemFragment}

  query GetBaseCarouselItemById($id: String!, $locale: String!, $preview: Boolean) {
    carouselItem(id: $id, locale: $locale, preview: $preview) {
      ...BaseCarouselItemFragment
    }
  }
`;

/**
 * Get a single CarouselItem by ID (standard - 1 level deep)
 */
export const getCarouselItemById = gql`
  ${CarouselItemFragment}

  query GetCarouselItemById($id: String!, $locale: String!, $preview: Boolean) {
    carouselItem(id: $id, locale: $locale, preview: $preview) {
      ...CarouselItemFragment
    }
  }
`;

/**
 * Get a single CarouselItem by ID (full - 2 levels deep)
 */
export const getFullCarouselItemById = gql`
  ${FullCarouselItemFragment}

  query GetFullCarouselItemById($id: String!, $locale: String!, $preview: Boolean) {
    carouselItem(id: $id, locale: $locale, preview: $preview) {
      ...FullCarouselItemFragment
    }
  }
`;

/**
 * Get all CarouselItem entries with pagination (base - scalars only)
 */
export const getBaseCarouselItems = gql`
  ${BaseCarouselItemFragment}

  query GetBaseCarouselItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CarouselItemOrder]
    $where: CarouselItemFilter
    $preview: Boolean
  ) {
    carouselItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseCarouselItemFragment
      }
    }
  }
`;

/**
 * Get all CarouselItem entries with pagination (standard - 1 level deep)
 */
export const getCarouselItems = gql`
  ${CarouselItemFragment}

  query GetCarouselItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CarouselItemOrder]
    $where: CarouselItemFilter
    $preview: Boolean
  ) {
    carouselItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...CarouselItemFragment
      }
    }
  }
`;

/**
 * Get all CarouselItem entries with pagination (full - 2 levels deep)
 */
export const getFullCarouselItems = gql`
  ${FullCarouselItemFragment}

  query GetFullCarouselItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CarouselItemOrder]
    $where: CarouselItemFilter
    $preview: Boolean
  ) {
    carouselItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullCarouselItemFragment
      }
    }
  }
`;
